import React from 'react'
import './modal.scss'
const Notification = ({title,description, okText="確定",onConfirm,btn02Text,onBnt02}) => {
  return (
    <div
    className='modal'
    >
        <div className='modal__block'>
            <p className='modal__block__title font-heading'>{title}</p>
            <p className='modal__block__description'>{description}</p>
            <div >
              <button className='btn' onClick={()=>onConfirm()}>{okText}</button>
              {
                btn02Text && (<button className='btn btn-text' style={{marginTop:8}} onClick={()=>onBnt02()}>{btn02Text}</button>)
              }
              
            </div>
        </div>
    </div>
  )
}

export default Notification